import {channelsListItemDimensions, channelsListSeparatorDimensions} from './ChannelsListDimensions';

export const getChannelsListItemLayout = (_: any, index: number) => ({
  length: channelsListItemDimensions.size,
  offset: (channelsListItemDimensions.size + channelsListSeparatorDimensions.horizontalContainerSize) * index,
  index
});
